export default "__VITE_ASSET__SuK$wKjy__"